import script from "./blog-v1.vue?vue&type=script&setup=true&lang=js"
export * from "./blog-v1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__